import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from "styled-components";
import { useTranslation } from "react-i18next";
import { api } from "../../services/axios";
import Toast from "../../components/Toast";
import {
  Box, Grid, Modal, Tooltip, TextField, CircularProgress, Button,
  FormControl, Backdrop,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/es';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import { FiEdit } from "react-icons/fi";
import { AiTwotoneDelete } from "react-icons/ai";
import { tint } from "polished";
import { shade } from "polished";
import {
  IconeSearch, IconClear, TitleModal, Overlay, Content,
  CloseModal, Btn, BtnCancel
} from "../styles";

export default function Feriado() {
  const { t } = useTranslation();
  const { colors } = useContext(ThemeContext);
  const [msgModal, setMsgModal] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openFeriado, setOpenFeriado] = useState(false);
  const handleOpenFeriado = () => setOpenFeriado(true);
  const handleCloseFeriado = () => setOpenFeriado(false);
  const [dtFeriado, setDtFeriado] = useState<Dayjs | null>(dayjs);
  const [day, setDay] = useState<Dayjs | null>(dayjs);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(9);
   
  const [values, setValues] = useState({
      day: "",
      name: "",
      companyId: 0
    });

  const [valuesFeriado, setOptions] = useState([{
    id: 0,
    day: "",
    name: "",
    companyId: 0
  }]);

  const [valuesEdit, setEdit] = useState({
    action: 0,
    title: "",
    id: 0,
    day: "",
    name: "",
    companyId: 0
  });

  const style = {
    position: "relative",
    width: "100%",
    padding: "40px 10px 10px",
    bgcolor: colors.c01,
    border: '0',
    boxShadow: 0,
    height: '96vh',
    color: colors.c04
  };

  const styleInput = {
    background: 'transparent',
    margin: '10px',
    input: {
      color: colors.c04
    },
    "input:-webkit-autofill, input:-webkit-autofill:focus": {
      transition: 'background-color 600000s 0s, color 600000s 0s'
    },
    '& .MuiSvgIcon-root': {
      color: colors.c04, // Cor do ícone
    },
    '& .MuiPickersDay-root': {
      color: colors.c04, // Cor dos dias
      '&.Mui-selected': {
        backgroundColor: colors.c01, // Fundo do dia selecionado
        color: colors.c04, // Cor do texto do dia selecionado
      },
      '&.Mui-selected:hover': {
        backgroundColor: shade(0.1, colors.c01), // Fundo ao passar o mouse no dia selecionado
      },
    },
    '& .MuiDateCalendar-root': {
      backgroundColor: colors.c01, // Fundo do cabeçalho
    },
    '& .MuiPickersSlideTransition-root': {
      backgroundColor: colors.c01, // Fundo do calendário
    },
    // Root class for the input field
    "& .MuiOutlinedInput-root": {
      background: 'transparent',
      borderColor: colors.c04,
      color: colors.c04,
      '& fieldset': { borderColor: colors.c04 },
      '&:hover fieldset': { borderColor: colors.c04 },
      '&.Mui-focused fieldset': { borderColor: colors.c04 },
      // Class for the border around the input field
      "& .MuiOutlinedInput-notchedOutline": {
        background: 'transparent',
        borderColor: colors.c04,
        borderWidth: "1px",
      },
    },
    // Class for the label of the input field
    "& .MuiInputLabel-outlined": {
      background: 'transparent',
      color: colors.c04
    },
    fieldset: {
      border: 0
    },
    "& label.Mui-focused": {
      background: 'transparent',
      color: colors.c04
    },
    "& .MuiInput-underline:after": {
      background: 'transparent',
      borderBottomColor: colors.c04
    },
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuPr = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    variant: "menu"
  };

  const getInit = async () => {
    try {
      var IdCompany = 1;
      setValues({ ...values, companyId: IdCompany });
      setEdit({ ...valuesEdit, companyId: IdCompany });
      setMsgModal("Pesquisando, aguarde!");
      clearSearch();
      setPage(0);
      handleOpen();
      const response = await api.get('/feriado?companyId=' + IdCompany)
      if (response.status === 200) {
        const { result } = response.data;
        setOptions(result)
      } else if (response.status === 400) {
        Toast({ type: "warn", message:  response.data.message });
      } else {
        Toast({ type: "error", message: response.data.message });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  };

  useEffect(() => {
    getInit();
  }, []);

  async function openModal(item: any, action: any) {
    if (action === 'insert') {
      setEdit({
        ...valuesEdit,
        action: 0,
        title: "Incluir Feriado",
        id: 0,
        day: "",
        name: "",
        companyId: 1
      });
      setDay(null);
    } else if (action === 'update' || action === 'delete') {
      setEdit({
        ...valuesEdit,
        action: (action === 'update') ? 1 : 2,
        title: (action === 'update') ? "Alterar Feriado": "Excluir Feriado",
        id: item.id,
        day: item.day,
        name: item.name,
        companyId: 1
      });
      setDay(dayjs(item.day, 'DD/MM/YYYY'));
    }
    handleOpenFeriado();
  };

  function clearSearch() {
    setValues({
      ...values,
      day: "",
      name: ""
    });
    setDtFeriado(null);
    setOptions([]);
  };

  //Pesquisar Feriado
  async function searchFeriado() {
    setMsgModal("Pesquisando, aguarde!");
    handleOpen();
    try {
      let query_filter = ''
      if (values.day !== "") {
        query_filter = query_filter + `&day=${values.day}`
      }

      if (values.name !== "") {
        query_filter = query_filter + `&name=${values.name}`
      }

      query_filter += `&page=1`;
      setPage(0);
      const response = await api.get("/feriado?companyId=1" + query_filter);
      if (response.status === 200) {
        const { result } = response.data;
        setOptions(result);
        handleClose();
      } else if (response.status === 400) {
        Toast({ type: "warn", message: response.data.message });
      } else {
        Toast({ type: "error", message: response.data.message });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  };

  //Criar Feriado
  async function saveFeriado() {
    try {
      setMsgModal("Alterando, aguarde!");
      handleOpen();
      const response = await api.post("/feriado", valuesEdit);
      if (response.status === 200) {
        handleCloseFeriado();
        Toast({ type: "success", message: response.data.message });
        handleClose();
        clearSearch();
        setOptions([]);
        searchFeriado();
      } else if (response.status === 400) {
        handleClose();
        Toast({ type: "warn", message: response.data.message });
      } else {
        handleClose();
        Toast({ type: "error", message:response.data.message });
      }
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  }

  // Apagar Feriado
  async function deleteFeriado(id: any) {
    try {
      setMsgModal("Excluindo, aguarde!");
      handleOpen();
      const response = await api.delete("/feriado/" + id);
      if (response.status === 200) {
        handleCloseFeriado();
        Toast({ type: "success", message: response.data.message });
        handleClose();
        clearSearch();
        setOptions([]);
        searchFeriado();
      } else if (response.status === 400) {
        handleClose();
        Toast({ type: "warn", message: response.data.message });
      } else {
        handleClose();
        Toast({ type: "error", message: response.data.message });
      }
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte."  });
    }
  }

  //Atualizar Feriado
  async function updateFeriado(id: any) {
    try {
      setMsgModal("Alterando, aguarde!");
      handleOpen();
      const response = await api.put("/feriado/" + id, valuesEdit);
      if (response.status === 200) {
        handleCloseFeriado();
        Toast({ type: "success", message:  response.data.message });
        handleClose();
        clearSearch();
        setOptions([]);
        searchFeriado();
      } else if (response.status === 400) {
        handleClose();
        Toast({ type: "warn", message: response.data.message });
      } else {
        handleClose();
        Toast({ type: "error", message: response.data.message });
      }
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  }

 const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  async function handleChange(item: any) {
    let { name, value } = item.target;
    setValues({ ...values, [name]: value });
  }

  const handleDtFeriado = (iniValue: any | null) => {
    if (iniValue !== null) {
      setDtFeriado(iniValue);
      setValues({ ...values, day : iniValue.format('DD/MM/YYYY') })
    }
  };

  async function handleChangeEdit(item: any) {
    let { name, value } = item.target;
    setEdit({ ...valuesEdit, [name]: value });
  };

  const handleDay = (iniValue: any | null) => {
    if (iniValue !== null) {
      setDay(iniValue);
      setEdit({ ...valuesEdit, day : iniValue.format('DD/MM/YYYY') })
    }
  };

  const modalContent = (
    <Overlay>
      <Content>
        <TitleModal>
          {valuesEdit.title}
        </TitleModal>
        <CloseModal onClick={() => handleCloseFeriado()} />
        {valuesEdit.action <= 1 ?
          <>
          <FormControl sx={{ m: 0, minWidth: 150, width: '23%', backgroundColor: colors.c01 }} size="small">
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                <DesktopDatePicker
                  label="Data Feriado"
                  sx={styleInput}
                  value={day}
                  onChange={(eventInt) => handleDay(eventInt)}
                  slotProps={{
                    textField: { size: 'small' },
                    calendarHeader: { sx: { backgroundColor: colors.c17, color: colors.c04 } },
                    previousIconButton: { sx: { color: colors.c04 } },
                    nextIconButton: { sx: { color: colors.c04 } },
                    day: { sx: { backgroundColor: colors.c01, color: colors.c04 } },
                    desktopPaper: { sx: { backgroundColor: colors.c17, color: colors.c04 } }
                  }}
                />
              </LocalizationProvider>
            </FormControl>
            <TextField
              sx={styleInput}
              style={{ width: '50%' }}
              size="small"
              variant="outlined"
              label="Descrição"
              type="text"
              required
              name="name"
              value={valuesEdit.name}
              onChange={handleChangeEdit}
            />
            <Box sx={{ '& button': { m: 1 } }}>
              <BtnCancel
                onClick={handleCloseFeriado} sx={{ float: 'right', backgroundColor: colors.c13, '&:hover': { opacity: 0.7, backgroundColor: colors.c13} }} variant="contained">
                <CloseIcon sx={{ fontSize: '16px', marginRight: '7px' }} />{t("person.Cancel")}
              </BtnCancel>
              <Btn sx={{backgroundColor: colors.c02, '&:hover': { opacity: 0.7, backgroundColor: colors.c02}}}
                onClick={() => valuesEdit.action === 0 ? saveFeriado() : updateFeriado(valuesEdit.id)} variant="contained">
                <CheckIcon sx={{ fontSize: '16px', marginRight: '7px' }} />Salvar
              </Btn>
            </Box>
          </>
          : valuesEdit.action === 2 ?
            <>
              <Box sx={{ margin: '10px' }}>
                <h3>Remover "{valuesEdit.name}" ?</h3>
              </Box>
              <Box sx={{ '& button': { m: 1 } }}>
                <BtnCancel
                  onClick={handleCloseFeriado} sx={{ float: 'right', backgroundColor: colors.c13, '&:hover': { opacity: 0.7, backgroundColor: colors.c13} }} variant="contained">
                  <CloseIcon sx={{ fontSize: '16px', marginRight: '7px' }} />{t("person.Cancel")}
                </BtnCancel>
                <Btn sx={{backgroundColor: colors.c02, '&:hover': { opacity: 0.7, backgroundColor: colors.c02}}}
                  onClick={() => deleteFeriado(valuesEdit.id)} variant="contained">
                  <DeleteForeverIcon sx={{ fontSize: '16px', marginRight: '7px' }} />{t("person.Remove")}
                </Btn>
              </Box>
            </>
            : <></>
        }
      </Content>
    </Overlay>

  );

  return (
    <Box sx={style}>
      <h4>Cadastro de Feriado</h4><Box py={1} />
      <Grid container spacing={2} direction="row">
        <Box px={0.5} />
         <FormControl sx={{ m: 0, minWidth: 150, width: '17%', backgroundColor: colors.c01 }} size="small">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <DesktopDatePicker
              label="Data Feriado"
              sx={styleInput}
              value={dtFeriado}
              onChange={(eventInt) => handleDtFeriado(eventInt)}
              slotProps={{
                textField: { size: 'small' },
                calendarHeader: { sx: { backgroundColor: colors.c17, color: colors.c04 } },
                previousIconButton: { sx: { color: colors.c04 } },
                nextIconButton: { sx: { color: colors.c04 } },
                day: { sx: { backgroundColor: colors.c01, color: colors.c04 } },
                desktopPaper: { sx: { backgroundColor: colors.c17, color: colors.c04 } }
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <TextField
          sx={styleInput}
          style={{ width: '50%' }}
          size="small"
          variant="outlined"
          label="Descrição"
          type="text"
          name="name"
          value={values.name}
          onChange={handleChange}
        />
        <Tooltip title="Consultar" placement="bottom-start" arrow>
          <Button size="small" onClick={() => searchFeriado()}
              sx={{ marginTop: '9px', marginBottom: '10px', backgroundColor: colors.c19, '&:hover': { opacity: 0.7, backgroundColor: colors.c19 } }}
              aria-label="Consultar">
              <IconeSearch size={18} color={colors.c05} />
          </Button>
        </Tooltip>
        <Box px={3} />
        <Tooltip title="Incluir" placement="bottom-start" arrow>
          <Button size="small" onClick={() => openModal('', 'insert')}
            sx={{ marginTop: '9px', marginBottom: '10px', backgroundColor: colors.c18, '&:hover': { opacity: 0.7, backgroundColor: colors.c18 } }}
            aria-label={t("person.include")}>
            <AddIcon sx={{ color: colors.c05, size: '18' }} />
          </Button>
        </Tooltip>
        <Box px={1} />
        <Tooltip title={t("person.clean")} placement="bottom-start" arrow>
          <Button size="small" onClick={() => clearSearch()}
            sx={{ marginTop: '9px', marginBottom: '10px', backgroundColor: colors.c13, '&:hover': { opacity: 0.7, backgroundColor: colors.c13 } }}
            aria-label={t("person.clean")}>
            <IconClear size={19} color={colors.c05} />
          </Button>
        </Tooltip>
      </Grid>
      <TableContainer sx={{ maxHeight: 400, backgroundColor: colors.c01, borderRadius: '5px' }} >
        <Table stickyHeader aria-label="sticky table" size={'small'}>
          <TableHead>
            <TableRow>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center" >Dia</TableCell>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center" >Descriçao</TableCell>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '11px' }} align="center" >{t("person.Actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              valuesFeriado && valuesFeriado.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                return (
                  <TableRow style={{ backgroundColor: index % 2 === 0 ? colors.c17 : shade(0.1, colors.c17) }} key={index}>
                    <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      {row.day}
                    </TableCell>
                    <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      {row.name}
                    </TableCell>
                    <TableCell
                      style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      <FiEdit
                        style={{ cursor: 'pointer', marginLeft: "5px" }}
                        color={tint(0.1, colors.c04)}
                        size="20"
                        title="Editar"
                        onClick={() => openModal(row, 'update')}
                      />
                      <AiTwotoneDelete
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                        color={colors.c04}
                        size="20"
                        title="Remover"
                        onClick={() => openModal(row, 'delete')}
                      />
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination sx={{ color: colors.c04 }}
        rowsPerPageOptions={[9]}
        component="div"
        count={valuesFeriado.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Box sx={{ textAlign: 'center', alignContent: 'center' }}>
        <Backdrop
          sx={(theme) => ({ color: colors.c04, zIndex: theme.zIndex.drawer + 1 })}
          open={open}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
          <Box px={1} />
          {msgModal}
        </Backdrop>
      </Box>
      <Modal open={openFeriado}
        onClose={handleCloseFeriado}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {modalContent}
      </Modal>
      
    </Box>
  );
}